import { useSelector, useDispatch } from 'react-redux';
import { addComponent, removeComponent, getSessionOptions } from '../../redux/slice/tanProfileSlice';
import React, { useState } from 'react';
import NavigationWrapper from '../../components/sessionNavigation/navigationWrapper';
import PopoverSelector from '../../components/popoverSelector/popoverSelector';
import { useTranslation } from 'react-i18next';
const ScentSelection = () => {
  const sessionOptions = useSelector((state) => state?.tanProfile?.profileMeta?.sessionTypes)
  const { t } = useTranslation("translation", { keyPrefix: "scentSelection" });
  return (
    <>
      <NavigationWrapper>
          <div className='session-header'>

            {t("title", "choose a Scent")}
          </div>

          <PopoverSelector itemtype={"scents"} amount={sessionOptions.includes("wellfit") ? 1 : 2} />
      </NavigationWrapper>
    </>
  );
};

export default ScentSelection;
